module.exports = __webpack_public_path__ + "img/banner1.e5cb24c3.png";